<template>
	<div class="logout-container">
		<div>
			Logging out...
		</div>
	</div>
</template>

<script>
	import logoutMixin from '@Mixin/logoutMixin';
	import profileMixin from '@Mixin/profileMixin';
	import navigationMixin from '@Mixin/navigationMixin';
	export default {
		mixins: [
			logoutMixin,
			profileMixin,
			navigationMixin
		],
		created() {
			if (!this.customer) {
				return;
			}
			const customerId = this.customer.id;
			if (!customerId) {
				this._navigateToHome();
				return;
			}
			this.$tpa.trackLogout(customerId);
			this.logout();
			location.reload();
		}
	}
</script>

<style lang="scss" scoped>
	.logout-container {
		display: flex;
		align-items: center;
		justify-content: center;
	
		width: 100vw;
		height: 50vh;
	}
</style>



// WEBPACK FOOTER //
// src/components/auth/Logout.vue